import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import UserService from "services/UserService";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  getAlerts,
  downloadFile, getMITMDashboard, getChartpoints,
  postMBMPointData, getChart, getChartV2, getMITMPolicies, getMITMComputers
} from "services/ConfigServices";
import { dashboardText } from "variables/MBM/geb";
import CustomSelect from "components/Input/CustomSelect.js";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle";
import { getChartCategoryScriptV2 } from "components/ChartV2/ChartV2";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ElectricMeterIcon from '@mui/icons-material/ElectricMeter';
import SpeedIcon from '@mui/icons-material/Speed';
import WifiIcon from '@mui/icons-material/Wifi';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import Button from "components/CustomButtons/Button.js";
import SpeakerPhoneIcon from '@mui/icons-material/SpeakerPhone';
import Columns from "./Charts/Columns";
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { NotificationManager } from 'react-notifications';
import { withStyles } from "@mui/styles";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ViewPointDataDialog from "./Plans/ViewPointDataDialog";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import uuid from "react-uuid";
import { getChartCategoryScript } from "components/Charts/getChartCategoryScript";
import { geittext } from "variables/MITM/geit";
import { definitionData as iotdefinitiondata } from "variables/MBM/lists/iotdevices";
import { definitionData as eqdefinitionData } from "variables/MBM/lists/equipments";
import { dico } from "variables/lists/dico";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import RefreshIcon from '@mui/icons-material/Refresh';
import RTComputers from "./Computers/RTComputers";
import { indicatorlist } from "variables/MITM/lists/geit";
import EnergyPoliciesSankey from "./Charts/EnergyPoliciesSankey";
import LastConnections from "./Charts/LastConnections";
// import { Menu, MenuItem } from "@mui/material";


const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "0",
  paddingTop: "0",
  paddingBottom: "0px",
  paddingRight: "2px",
  paddingLeft: "2px",
  fontFamily: '"Source Sans Pro",sans-serif',
  color: "#000000",
  background: "transparent",
  boxShadow: "none",
};

const PlanImgContainer = styled.div`
  // height: 400px;
  width: calc(100% - 100px);
  display: block;
  position: relative;
`;

const PlanMenuButton = styled.div`
    width:30px;
    height:30px;
    padding-top: 3px;
    padding-left: 3px;
    margin-right: 5px;
    cursor: pointer;
    border: 1px solid;
    border-color: #8080804d;
    border-radius: 4px;
`;



const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;

const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;

const cardHeaderStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: 'row',
  flexWrap: 'nowrap',
};

const cardHeaderIndicatorStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'flex-start',
  paddingTop: '0px',
};
const cardBodyIndicatorStyle = {
  paddingTop: '5px',
  paddingBottom: '5px',
};
const cardBody2DPlanStyle = {
  display: 'flex',
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles((theme) => ({
  planicon: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planicongreen: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    color: "#91C73C",
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planmenu: {
    display: 'flex',
  },
  plansubmenu: {
    display: 'flex',
    marginTop: 7,
    marginLeft: 5,
  },
  planmenuicon: {
    width: "20px",
    height: "20px",
    marginLeft: "1px",
    marginTop: "1px",
  },
  planmenubutton: {
    background: "#FFFFFF"
  },
  planmenubuttonpressed: {
    background: "#91C73C"
  },
  planmenubuttonfspressed: {
    background: "#9798A0"
  },
}));

const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const getDateBeginFromPeriod = (period) => {
  let date = moment();
  if (period === 'oneweek') {
    date = date.add(-7, 'd');
    // date = date.set('h',0);
  }
  else if (period === 'oneyear') {
    date = date.add(-365, 'd');
    // date = date.set('h',0);
  }
  return date.format("YYYY-MM-DD");
}
const getDateEndFromPeriod = (period) => {
  let date = moment();
  if (period === 'oneweek') {

    // date = date.set('h',0);
  }
  return date.format("YYYY-MM-DD");
}

const Dashboard = (props) => {
  const targetRef = useRef();
  const classes = useStyles();
  const classes2 = useStyles2();
  const appContext = useContext(AdvancedSearchContext);
  const { architecture } = appContext;

  const { currentWorkspace, editionmode } = props;
  const [wpgrouplist, setWpgrouplist] = useState([]);

  const [connectivityDashboardData, setConnectivityDashboardData] = useState("");
  const [alertsData, setAlertsData] = useState("");

  const [fullpointdata, setFullpointdata] = useState([]);
  const [pointdata, setPointdata] = useState([]);
  const [iotdata, setIotdata] = useState([]);
  const [computersdata, setComputersdata] = useState([]);
  const [selectedComputers, setSelectedComputers] = useState([]);
  const [filteredComputers, setFilteredComputers] = useState([]);
  const [policiesdata, setPoliciesdata] = useState([]);

  const [currentDataItem, setCurrentDataItem] = useState("");

  const [indicator, setIndicator] = useState("policies");

  const [openplanitemdata, setOpenplanitemdata] = useState(false);

  const [openMenumeteringplan, setOpenmenumeteringplan] = useState(null);
  const [openMenu2dplan, setOpenmenu2dplan] = useState(null);


  const [planrawdata, setPlanrawdata] = useState([]);
  const [plan1hdata, setPlan1hdata] = useState([]);
  const [plan1ddata, setPlan1ddata] = useState([]);
  const [planDatatime, setPlandatatime] = useState(moment());
  const [plan2dloaded, setPlan2dloaded] = useState(false);
  const [planrefreshdataLock, setPlanrefreshdataLock] = useState(true);
  const [fullscreen2D, setFullscreen2D] = useState(false);
  const [move2ditem, setMove2ditem] = useState(false);

  const [plan2ddisplayeq, setPlan2ddisplayeq] = useState(true);
  const [plan2ddisplayiot, setPlan2ddisplayiot] = useState(true);


  const [chart1, setChart1] = useState();
  const [chart2, setChart2] = useState();

  const handleOpenplanitemdata = (event) => { setOpenplanitemdata(true); };
  const handleCloseplanitemdata = (event) => { setOpenplanitemdata(false); };

  const handleIndicatorChange = (event) => { setIndicator(event.target.value); };

  const viewitemdata = (item) => {
    setCurrentDataItem(item.avobitem);
    handleOpenplanitemdata();
  }


  const getFullscreen2D = () => {
    setFullscreen2D(true);
  };
  const handleFullscreen2DClose = () => {
    setFullscreen2D(false);
  };


  //worskpace
  useEffect(() => {

    if (currentWorkspace) {
      let wpgrouplisttmp = [];
      let workspacegroup = currentWorkspace.idgroup;
      if (workspacegroup) {
        //dashboard
        axios
          .get(getMITMDashboard(workspacegroup), {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          })
          .then((res) => {
            let datatmp = [{ name: geittext.desktop, pcinactives: res.data?.pcinactivesdesk, pcsaver: res.data?.pcsaverdesk, pcviewer: res.data?.pcviewerdesk },
            { name: geittext.laptop, pcinactives: res.data?.pcinactiveslap, pcsaver: res.data?.pcsaverlap, pcviewer: res.data?.pcviewerlap },];
            console.log(datatmp);
            setConnectivityDashboardData(datatmp);
          });
        //Alerts
        axios
          .get(getAlerts(workspacegroup, null, null, null, null, 'count'), {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          })
          .then((res) => {
            setAlertsData(res.data);
          });
        //points
        axios
          .get(
            getChartpoints(workspacegroup),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            setPointdata(res.data.points || []);
          })
          .catch(() => { });



        //pc
        axios
          .get(
            getMITMComputers(workspacegroup),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            setComputersdata(res.data.computers || []);
          })
          .catch(() => { });

        //policies
        axios
          .get(
            getMITMPolicies(workspacegroup),
            {
              headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
              },
            }
          )
          .then((res) => {
            setPoliciesdata(res.data.policies || []);
          })
          .catch(() => { });


        //grouplistfromthisgroup
        searchworkspacegroup(architecture, wpgrouplisttmp, workspacegroup, false, "");
        setWpgrouplist(wpgrouplisttmp);
      }

      //charts

      let chart1 = currentWorkspace.parameters?.chart1;
      if (chart1) {
        let datebegin = getDateBeginFromPeriod(chart1.period);
        let dateend = getDateEndFromPeriod(chart1.period);
        const requestid = uuid();
        let chartsource = 'existing';
        let url = '';
        if (chart1.version && chart1.version === 'v2') {
          url = getChartV2(workspacegroup, chart1.chart, datebegin, dateend, false, chartsource, '', requestid);
        }
        else {
          url = getChart(workspacegroup, chart1.chart, datebegin, dateend, false, chartsource, '', '', '', '', '', '', '', requestid);
        }
        let datetitle = moment(datebegin).format('DD/MM/yyyy') + " au " + moment(dateend).format('DD/MM/yyyy');
        axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
          .then((response) => {
            let resultchart = {};
            resultchart.serverData = response.data.chart;
            if (resultchart?.serverData?.title)
              resultchart.serverData.title = resultchart.serverData.title + " (" + datetitle + ")";
            if (resultchart?.serverData?.name)
              resultchart.serverData.name = resultchart.serverData.name + " (" + datetitle + ")";
            if (resultchart.serverData.version === 'v1') {
              resultchart = getChartCategoryScript(
                resultchart.serverData?.data,
                resultchart.serverData?.title,
                resultchart.serverData?.category,
                resultchart.serverData?.type,
                resultchart.serverData?.stacking,
                resultchart.chart,
                true
              )[0];
              ;
            }
            else {
              resultchart = getChartCategoryScriptV2(resultchart.serverData, chart1.chart, "", true, "285px");
            }
            setChart1(resultchart);
          })
          .catch((error) => {
            console.error(error);
          })
      }
      else
        setChart1("");

      let chart2 = currentWorkspace.parameters?.chart2;
      if (chart2) {
        let datebegin2 = getDateBeginFromPeriod(chart2.period);
        let dateend2 = getDateEndFromPeriod(chart2.period);
        const requestid2 = uuid();
        let chartsource = 'existing';
        let url2 = '';
        if (chart2.version && chart2.version === 'v2') {
          url2 = getChartV2(workspacegroup, chart2.chart, datebegin2, dateend2, false, chartsource, '', requestid2);
        }
        else {
          url2 = getChart(workspacegroup, chart2.chart, datebegin2, dateend2, false, chartsource, '', '', '', '', '', '', '', requestid2);
        }
        let datetitle2 = moment(datebegin2).format('DD/MM/yyyy') + " au " + moment(dateend2).format('DD/MM/yyyy');
        axios.get(
          url2,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
          .then((response) => {
            let resultchart = {};
            resultchart.serverData = response.data.chart;
            if (resultchart?.serverData?.title)
              resultchart.serverData.title = resultchart.serverData.title + " (" + datetitle2 + ")";
            if (resultchart?.serverData?.name)
              resultchart.serverData.name = resultchart.serverData.name + " (" + datetitle2 + ")";
            if (resultchart.serverData.version === 'v1') {
              resultchart = getChartCategoryScript(
                resultchart.serverData?.data,
                resultchart.serverData?.title,
                resultchart.serverData?.category,
                resultchart.serverData?.type,
                resultchart.serverData?.stacking,
                resultchart.chart,
                true
              )[0];
              ;
            }
            else {
              resultchart = getChartCategoryScriptV2(resultchart.serverData, chart2.chart, "", true);
            }
            setChart2(resultchart);
          })
          .catch((error) => {
            console.error(error);
          })
      }
      else
        setChart2("");

    }
  }, [currentWorkspace]);

  const searchworkspacegroup = (archi, grouplist, wpgroupid, found, fatherpath) => {
    archi.forEach((group) => {
      let newpath = fatherpath + "/" + group.text;
      if (found || group.id == wpgroupid) {
        let newgp = {};
        newgp.name = newpath;
        newgp.id = group.id;
        grouplist.push(newgp);
        found = true;
      }
      if (group.children && group.children.length > 0) {
        searchworkspacegroup(group.children, grouplist, wpgroupid, found, newpath);
      }
    })
  }



  return (
    <>
      {
        currentWorkspace ?
          <>
            {
              ((connectivityDashboardData || alertsData) && !fullscreen2D) ?
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <GridContainer >
                    <GridItem xs={12} sm={12} md={chart2 ? 3 : 6} lg={chart2 ? 3 : 6}>
                      {chart1}
                    </GridItem>
                    {
                      chart2 ?
                        <GridItem xs={12} sm={12} md={3} lg={3}>
                          {chart2}
                        </GridItem> : <></>
                    }

                    {
                      connectivityDashboardData ?
                        <GridItem xs={12} sm={12} md={3} lg={3}>
                          <Card style={{ height: '329px', marginTop: '15px', marginBottom: '10px' }}>
                            <CardHeader style={cardHeaderIndicatorStyle}>
                              <h4 className={classes.cardIconTitleSimpleCard}>{geittext.pcstate}</h4>
                            </CardHeader>
                            <CardBody style={cardBodyIndicatorStyle}>
                              <Columns
                                data={connectivityDashboardData}
                              ></Columns>
                            </CardBody>
                          </Card>
                        </GridItem> : <></>
                    }
                    {
                      alertsData ?
                        <GridItem xs={12} sm={12} md={3} lg={3}>
                          <Card style={{ height: '329px', marginTop: '15px', marginBottom: '10px' }}>
                            <CardHeader style={cardHeaderIndicatorStyle}>
                              <h4 className={classes.cardIconTitleSimpleCard}>{dashboardText.alerts}</h4>
                            </CardHeader>
                            <CardBody style={cardBodyIndicatorStyle}>
                              <DataList>
                                <DataContainer>
                                  <Data>{dashboardText.alertcritical + " : "}</Data>
                                  <DataResult>{(alertsData.unreadcritical + alertsData.progresscritical)}</DataResult>
                                </DataContainer>
                                <DataContainer>
                                  <Data>{dashboardText.alertimportant + " : "}</Data>
                                  <DataResult>{(alertsData.unreadimportant + alertsData.progressimportant)}</DataResult>
                                </DataContainer>
                                <DataContainer>
                                  <Data>{dashboardText.alertwarning + " : "}</Data>
                                  <DataResult>{(alertsData.unreadwarning + alertsData.progresswarning)}</DataResult>
                                </DataContainer>
                                <DataContainer>
                                  <Data>{dashboardText.alertinfo + " : "}</Data>
                                  <DataResult>{(alertsData.unreadinfo + alertsData.progressinfo)}</DataResult>
                                </DataContainer>
                              </DataList>
                            </CardBody>
                          </Card>
                        </GridItem>
                        : <></>
                    }

                  </GridContainer>
                </GridItem>
                : <></>
            }

            <GridItem xs={12} sm={12} md={12} lg={12}>
              <GridContainer >
                {
                  fullscreen2D ?
                    <></> :
                    <GridItem xs={12} sm={12} md={4} lg={4}>
                      <GridContainer >
                        {/* AUTOMATION */}
                        {currentWorkspace.parameters?.displayAutomationWidget &&
                          <GridItem xs={12} sm={12} md={12} lg={12}>

                          </GridItem>
                        }



                        {/* METERING PLAN */}
                        <GridItem xs={12} sm={12} md={12} lg={12}>
                          <Card style={{ marginTop: '10px' }}>
                            <CardHeader style={cardHeaderStyle}>
                              <h4 className={classes.cardIconTitleSimpleCard}>{geittext.indicators}</h4>
                              <div>
                                <CustomSelect
                                  marginTop={5}
                                  width={200}
                                  inputTitle={geittext.indicators}
                                  selectValue={indicator}
                                  handleSelectValueChange={handleIndicatorChange}
                                  data={indicatorlist}
                                  small
                                />
                              </div>

                            </CardHeader>
                            <CardBody>
                              {
                                indicator === 'policies' ?
                                  <EnergyPoliciesSankey
                                    computers={filteredComputers}
                                    policies={policiesdata}
                                  /> : indicator === 'lastconnexion' ?
                                    <LastConnections
                                      computers={filteredComputers}
                                    /> : <></>

                              }
                            </CardBody>
                          </Card>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                }

                <GridItem xs={12} sm={12} md={fullscreen2D ? 12 : 8} lg={fullscreen2D ? 12 : 8}>
                  <GridContainer sx={{ height: "100%" }}>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      {/* 2D PLAN */}
                      <Card style={{ height: "calc(100% - 30px)", marginTop: '10px' }}>
                        <CardHeader style={cardHeaderStyle}>
                          <h4 className={classes.cardIconTitleSimpleCard}>{geittext.pclist}</h4>
                          <div className={classes2.planmenu}>
                            <div className={classes2.plansubmenu}>
                              <Tooltip title={dashboardText.refresh} style={{ marginLeft: "15px" }}>
                                <PlanMenuButton
                                  color={"success"}
                                  // onClick={refreshPlan2DData}
                                  className={planrefreshdataLock ? classes2.planmenubuttonfspressed : classes2.planmenubutton}
                                  disabled={planrefreshdataLock}
                                >
                                  <RefreshIcon />
                                </PlanMenuButton>
                              </Tooltip>

                              <Tooltip title={dashboardText.fullscreen}>
                                <PlanMenuButton
                                  color={"success"}
                                  className={fullscreen2D ? classes2.planmenubuttonfspressed : classes2.planmenubutton}
                                  onClick={fullscreen2D ? handleFullscreen2DClose : getFullscreen2D}
                                >
                                  <FullscreenIcon className={classes2.planmenuicon} />
                                </PlanMenuButton>
                              </Tooltip>
                            </div>
                            {editionmode ?
                              <>
                                <Button
                                  id="basic-button2"
                                  aria-controls={openMenu2dplan ? 'basic-menu2' : undefined}
                                  aria-haspopup="true"
                                  aria-expanded={openMenu2dplan ? 'true' : undefined}
                                  // onClick={handleClickMenu2dplan}
                                  style={menuButtonStyle}
                                >
                                  <MenuIcon />
                                </Button>
                                <Menu
                                  id="basic-menu2"
                                  anchorEl={openMenu2dplan}
                                  open={Boolean(openMenu2dplan)}
                                  // onClose={handleCloseMenu2dplan}
                                  MenuListProps={{
                                    'aria-labelledby': 'basic-button2',
                                  }}
                                >
                                  {/* <MenuItem onClick={handleAdd2dPlan} key={`handleadd2dplan`}>
                                    {dashboardText.menu2dplanaddplan}
                                  </MenuItem> */}

                                  {
                                    // plan2d &&
                                    // <MenuItem onClick={handleEdit2dPlan} key={`handleedit2dplan`}>
                                    //   {dashboardText.menu2dplaneditplan}
                                    // </MenuItem>
                                  }
                                </Menu>
                              </>
                              : <></>
                            }
                          </div>
                        </CardHeader>
                        <CardBody style={{ paddingTop: "0px" }} >
                          <RTComputers
                            computers={computersdata}
                            policies={policiesdata}
                            selectedComputers={selectedComputers}
                            setSelectedComputers={setSelectedComputers}
                            filteredComputers={filteredComputers}
                            setFilteredComputers={setFilteredComputers}
                          >

                          </RTComputers>
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </GridItem></>
          : <></>
      }


      {/* Dialogue pour les données d'un élément */}
      <Dialog
        onClose={handleCloseplanitemdata}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={openplanitemdata}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseplanitemdata}>
          {dashboardText.dataof + currentDataItem?.parameters?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewPointDataDialog
            currentItem={currentDataItem}
            closeModal={handleCloseplanitemdata}
            pointdata={pointdata}
            planrawdata={planrawdata}
            plan1ddata={plan1ddata}
            plan1hdata={plan1hdata}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>

    </>
  );
};

export default Dashboard;
